document.addEventListener('DOMContentLoaded', function () {

    const relatedSlider = document.querySelector('.bls-related-slider');

    if (!relatedSlider) return;

    new Swiper(relatedSlider, {

        slidesPerView: 2.2,
        spaceBetween: 20,

        navigation: {
            nextEl: '.bls-related-next',
            prevEl: '.bls-related-prev'
        },

        breakpoints: {

            768: {
                slidesPerView: 4
            },

            1200: {
                slidesPerView: 7
            }

        }

    });

});